import { useIntegrations } from '~/hooks/reactQuery/queries/useIntegrations';
import { useStoreActions } from '~/store/store-context';
import { useMutationState } from '../useMutationState';
export const useConnectStanfordTax = ()=>{
    const { api } = useStoreActions();
    const { refresh: refreshIntegrations } = useIntegrations({
        enabled: false
    });
    const { mutate, isPending } = useMutationState({
        mutationFn: (request)=>api.stanfordTax.connect(request),
        onSuccess: async ()=>{
            await refreshIntegrations({
                throwOnError: false
            });
        }
    });
    return {
        connectStanfordTax: mutate,
        isLoading: isPending
    };
};
